// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"e_ZB","legend":"e__B","legendContent":"e_0B","contentWrapper":"e_1B","fieldsetContent":"e_2B"};